"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYASSHU_URL = exports.IC_HOST = void 0;
exports.IC_HOST = 'https://ic0.app/';
exports.KYASSHU_URL = 'https://kyasshu.fleek.co';
